import { MouseEventHandler, useEffect, useState } from 'react'
import { ImageSearchIcon } from '~/components/icons/generated/ImageSearchIcon'
import { useTutorial } from '../../hooks/useTutorial'
import { sendGtmEvImageSearchButton } from '../../lib/gtmEvent'
import { ImageSearchTutorial } from './ImageSearchTutorial'

type Props = {
  onClick?: MouseEventHandler<HTMLButtonElement>
}

export const ImageSearchButton: React.FC<Props> = ({ onClick }) => {
  const { close, closed } = useTutorial()
  const [visibleTutorial, makeTutorialVisible] = useState(false)

  useEffect(() => {
    if (closed) return makeTutorialVisible(false)
    const id = window.setTimeout(() => makeTutorialVisible(true), 2000)
    return () => window.clearTimeout(id)
  }, [closed])

  return (
    <div className="relative">
      <div
        className={`absolute left-1/2 -translate-x-1/2 translate-y-[-122%] duration-200 ease-linear ${
          visibleTutorial
            ? 'translate-y-0 opacity-100'
            : 'pointer-events-none -translate-y-full opacity-0'
        }`}
      >
        {!closed && <ImageSearchTutorial onClick={close} />}
      </div>
      <button
        onClick={(e) => {
          close()
          onClick?.(e)
          sendGtmEvImageSearchButton()
        }}
        type="button"
        className="flex size-[30px] items-center justify-center rounded-full bg-white text-black-400/70 opacity-85 shadow-icon"
      >
        <ImageSearchIcon
          className="h-4"
          aria-label="似ているアイテムを検索する"
        />
      </button>
    </div>
  )
}
